import { AssetSupportingDocumentSchema, AssetSupportingDocumentListResponseSchema, } from '@packages/types';
import { api, apiRaw, getApiUrl, getApiBridge, parseErrorResponse, filenameFromResponse } from '../client.js';
const path = (accountId, ledgerId, assetId) => `/accounts/${accountId}/ledgers/${ledgerId}/assets/${assetId}/documents`;
export function listAssetSupportingDocuments(accountId, ledgerId, assetId) {
    return api(path(accountId, ledgerId, assetId), AssetSupportingDocumentListResponseSchema);
}
export async function uploadAssetSupportingDocument(accountId, ledgerId, assetId, file) {
    const bridge = getApiBridge();
    const form = new FormData();
    form.append('file', file);
    const token = bridge.getToken();
    const response = await fetch(`${getApiUrl()}${path(accountId, ledgerId, assetId)}`, {
        method: 'POST', headers: token ? { Authorization: `Bearer ${token}` } : {}, body: form,
    });
    if (response.status === 401) {
        bridge.removeToken();
        bridge.onUnauthorized();
        throw new Error('Session expired');
    }
    if (!response.ok)
        throw await parseErrorResponse(response);
    return AssetSupportingDocumentSchema.parse(await response.json());
}
export async function deleteAssetSupportingDocument(accountId, ledgerId, assetId, documentId) {
    await apiRaw(`${path(accountId, ledgerId, assetId)}/${documentId}`, { method: 'DELETE' });
}
export async function downloadAssetSupportingDocument(accountId, ledgerId, assetId, documentId) {
    const bridge = getApiBridge();
    const token = bridge.getToken();
    if (!token) {
        bridge.onUnauthorized();
        throw new Error('Session expired');
    }
    const response = await fetch(`${getApiUrl()}${path(accountId, ledgerId, assetId)}/${documentId}`, { headers: { Authorization: `Bearer ${token}` } });
    if (response.status === 401) {
        bridge.removeToken();
        bridge.onUnauthorized();
        throw new Error('Session expired');
    }
    if (!response.ok)
        throw await parseErrorResponse(response);
    const blobUrl = URL.createObjectURL(await response.blob());
    if (!window.open(blobUrl, '_blank')) {
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filenameFromResponse(response, 'document');
        link.click();
    }
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
}
